import {mix, Eventable} from '@kids/lib/mixin';

const eventBus = mix({}).with(Eventable);

export default eventBus;
